<template>
  <div class="div_principal">
    <div class="div_imagem"></div>
    <div class="div_login">
      <img src="/images/demode.png" id="logo" />

      <div class="formulario">
        <div class="inputContainer">
          <label>Usuário</label>
          <input type="text" class="input" v-model="state.login" v-mask-cpf />
        </div>
        <div class="inputContainer">
          <label>Senha</label>
          <input type="password" class="input" v-model="state.password" />
        </div>
        <button type="button" class="btn_entrar" @click="logar()">
          Entrar
        </button>

        <!-- Div para exibir retornos do Laravel -->
        <div v-if="state.message.show" class="alert" :class="state.message.type" role="alert"
          style="width: 80%; margin: 20px auto; text-align: left;">
          <i :class="state.message.icon"></i>
          {{ state.message.text }}
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { reactive } from "vue";
import services from "../../services";
//import { useField } from "vee-validate";
import { useRouter } from "vue-router";
import { useStorage } from "vue3-storage";
/*
const body = document.getElementsByTagName("body")[0];
*/
export default {
  setup() {
    const state = reactive({
      login: "",
      password: "",
      message: {
        show: false,
        type: "",
        text: "",
        icon: ""
      }
    });
    const router = useRouter();
    const storage = useStorage();
    function showMessage(type, text, icon) {
      state.message.show = true;
      state.message.type = type;
      state.message.text = text;
      state.message.icon = icon;

      // Auto-hide message after 5 seconds
      setTimeout(() => {
        state.message.show = false;
      }, 5000);
    }

    async function logar() {
      // Reset message
      state.message.show = false;

      if (
        state.login == null ||
        state.login == undefined ||
        state.login == ""
      ) {
        showMessage("alert-warning", "Insira um usuário!", "bi bi-exclamation-triangle");
        return;
      }
      if (
        state.password == null ||
        state.password == undefined ||
        state.password == ""
      ) {
        showMessage("alert-warning", "Insira uma senha!", "bi bi-exclamation-triangle");
        return;
      }

      try {
        const { data } = await services.colaboradores.login({
          login: state.login,
          password: state.password,
        });

        if (data) {
          // Use message from Laravel response or fallback
          const successMessage = data.message || "Login realizado com sucesso! Redirecionando...";
          showMessage("alert-success", successMessage, "bi bi-check-circle");

          storage.setStorageSync("cliente_token", data.token);
          storage.setStorageSync("nome", data.nome);
          storage.setStorageSync("colaborador_id", data.id);

          // Delay redirect to show success message
          setTimeout(() => {
            router.push("/dashboard/pagina-inicial");
          }, 1500);
        }
      } catch (error) {
        console.log(error);

        // Handle Laravel error responses
        if (error.response) {
          const errorData = error.response.data;

          // Check for Laravel message in different properties
          let errorMessage = null;

          if (errorData.erro) {
            errorMessage = errorData.erro;
          } else if (errorData.message) {
            errorMessage = errorData.message;
          } else if (error.response.status === 422) {
            // Validation errors from Laravel
            const validationErrors = errorData.errors;
            if (validationErrors) {
              errorMessage = Object.values(validationErrors)[0][0];
            }
          }

          // If we have a message from Laravel, use it
          if (errorMessage) {
            showMessage("alert-danger", errorMessage, "bi bi-x-circle");
          } else {
            // Fallback messages based on status
            if (error.response.status === 401) {
              showMessage("alert-danger", "Credenciais inválidas. Verifique seus dados.", "bi bi-x-circle");
            } else if (error.response.status === 422) {
              showMessage("alert-danger", "Erro de validação", "bi bi-x-circle");
            } else if (error.response.status === 500) {
              showMessage("alert-danger", "Erro interno do servidor. Tente novamente.", "bi bi-x-circle");
            } else {
              showMessage("alert-danger", "Erro desconhecido. Tente novamente.", "bi bi-x-circle");
            }
          }
        } else if (error.request) {
          showMessage("alert-danger", "Erro de conexão. Verifique sua internet.", "bi bi-wifi-off");
        } else {
          showMessage("alert-danger", "Erro inesperado. Tente novamente.", "bi bi-x-circle");
        }
      }
    }
    return {
      state,
      logar,
    };
  } /*
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },*/,
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");

.div_imagem {
  background-image: url("/images/smart_login.png");
  width: 70%;
  height: 100vh;
  float: left;
  background-size: 100% 100%;
}

.pi-eye {
  transform: scale(1.6);
  margin-right: 1rem;
}

.pi-eye-slash {
  transform: scale(1.6);
  margin-right: 1rem;
}

#app {
  height: 100%;
}

.div_principal {
  background-color: #fef9ff !important;
  height: 100vh;
}

.div_login {
  background-color: #fef9ff;
  float: left;
  width: 30%;
  text-align: center;
  padding-top: 100px;
}

#logo {
  width: 50%;
}

.input {
  width: 100%;
}

.btn_entrar {
  width: 80%;
  background-color: #560382;
  color: #fff;
  padding: 9px;
  border: none;
  border-radius: 5px;
  font-size: 12pt;
  font-weight: bold;
}

.inputContainer {
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  margin-bottom: 10px;
  width: 80%;
}

.formulario {
  margin-top: 46px;
  text-align: center;
}

input {
  border: #efefef solid 1px !important;
  background-color: #fbfbfb !important;
  padding: 13px;
  font-size: 11pt;
  margin-bottom: 5px;
  margin-top: 5px;
}

button {
  margin-top: 40px;
  cursor: pointer;
}

label {
  font-size: 12pt;
  font-weight: bold;
  margin-bottom: 0;
}

a {
  color: #560382 !important;
  font-weight: 400;
  font-size: 10pt;
}

.conta {
  font-size: 10pt;
}

/* Estilos para as mensagens de retorno */
.alert {
  border-radius: 5px;
  padding: 12px 15px;
  font-size: 11pt;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.alert-success {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
}

.alert-danger {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}

.alert-warning {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  color: #856404;
}

.alert i {
  font-size: 14pt;
}

@media (min-width: 576px) and (max-width: 767px) {
  .div_imagem {
    background-image: url("/images/smart_login.png");
    width: 70%;
    height: 100vh;
    float: left;
    background-size: cover;
    background-position: center;
  }
}

@media screen and (max-width: 575px) {
  .div_imagem {
    display: none;
  }

  .div_login {
    width: 100%;
  }
}
</style>
